import { Map, List } from 'immutable'

import { SET_OPTIONS, SELECT_LOCATION, SELECT_DIAL, SET_CAMPAIGN } from './actions'

export const initialState = new Map({
  locations: new List(),
  selected_location: '',
  selected_dial: '',
  loaded: false,
  employee: null,
  campaignId: null,
  organization: null,
  token: null
})

const optionsReducer = (state = initialState, action = { type: null }) => {
  switch (action.type) {
    case SET_OPTIONS:
      return state
        .set('locations', new List(action.data.locations))
        .set('employee', action.data.employee)
        .set('organization', action.data.organization)
        .set('loaded', true)
    case SELECT_LOCATION:
      return state.set('selected_location', action.data)
    case SELECT_DIAL:
      return state.set('selected_dial', action.data)
    case SET_CAMPAIGN:
      return state.set('campaignId', action.data.campaignId).set('token', action.data.token)
    default:
      return state
  }
}

export default optionsReducer
